import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SettingsService } from 'src/app/services/settings.service';
import { Share } from '@capacitor/share';
import { CustomerContact } from 'src/app/classes/customer-contact';
import { CustomerService } from 'src/app/services/customer.service';
import * as fa from '@fortawesome/free-solid-svg-icons';
@Component({
  selector: 'app-referrals',
  templateUrl: './referrals.component.html',
  styleUrls: ['./referrals.component.scss'],
})
export class ReferralsComponent implements OnInit {

  fa = fa
  currentUser = new CustomerContact()
  referrals: CustomerContact[] = []
  canShare = false
  locale = $localize.locale
  referralLink = 'https://nuuduu.com/' + this.locale

  constructor(public activeModal: NgbActiveModal,
    private settingsService: SettingsService,
    private customerService: CustomerService
  ) { }

  ngOnInit() {
    Share.canShare().then((res) => {
      this.canShare = res.value  
    })

    this.customerService.current().subscribe(contact => {
      this.currentUser = contact
      this.referralLink = 'https://nuuduu.com/' + this.locale + '?r=' + this.currentUser.referral_code
    })

    this.settingsService.referrals().subscribe(referrals => {
      this.referrals = referrals
    })
  }

  copyLink() {
    navigator.clipboard.writeText(this.referralLink).then().catch(e => console.log(e));
  }
  
  async share() {
    await Share.share({
      url: 'https://nuuduu.com/' + $localize.locale + (this.currentUser.referral_code ? '?r=' + this.currentUser.referral_code : ''),
    })
  }
}
